<template>
  <b-modal
    hide-footer
    ref="modal-view"
    size="xl"
    :title="modelId > 0 ? 'Edición de proveedor' : 'Nuevo proveedor'"
  >
    <b-overlay :show="loading" no-wrap></b-overlay>
    <div>
      <b-tabs content-class="mt-3" vertical no-fade pills card small>
        <b-tab title="General" active>
          <b-form @submit="onSubmit">
            <FormGroupBox title="Datos">
              <b-form-row>
                <b-form-group class="col-4" label="Codigo">
                  <b-form-input
                    type="text"
					:disabled="unableEdit"
                    size="sm"
                    v-model="modelInfo.code"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Nombre comercial">
                  <b-form-input
                    type="text"
					:disabled="unableEdit"
                    size="sm"
                    v-model="modelInfo.name"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Estado">
                  <b-form-select
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.status"
                    :options="statusOptions"
                  ></b-form-select>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group class="col-4" label="RFC">
                  <b-form-input
                    type="text"
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.taxName"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Servicios OnDemand (UBER)">
                  <b-form-select
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.onDemandServices"
                    :options="[
                      { value: true, text: 'SI' },
                      { value: false, text: 'NO' },
                    ]"
                  ></b-form-select>
                </b-form-group>
              </b-form-row>
				<b-form-row>
				<b-form-group class="col-6" label="Descripcion">
					<b-textarea :disabled="unableEdit" size="sm" v-model="modelInfo.description" />
				</b-form-group>
				</b-form-row>
				<hr>
				<b-form-row>
					<b-form-group class="col-9">
						<template slot="label">Email para notificaciones <md-icon icon="info" class="text-warning"></md-icon></template>
						<b-form-input
							type="text"
							size="sm"
							:disabled="unableEdit"
							v-model="modelInfo.emailNotifications"
						/>
					</b-form-group>

					<b-form-group class="col-3">
						<template slot="label">Lenguaje notificaciones</template>
						<b-form-select
						size="sm"
						v-model="modelInfo.languageNotifications"
						:options="langOptions">
						</b-form-select>
					</b-form-group>
				</b-form-row>
            </FormGroupBox>
            <div class="text-right">
              <b-button :disabled="unableEdit" variant="primary" type="submit">{{
                modelId > 0 ? "Actualizar" : "Guardar"
              }}</b-button>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Tipos de servicio" v-if="modelId > 0 ">
          <FormGroupBox title="Tipos de servicio registrados">
            <ServiceTypeTable class="mt-3" embbebedOnSupplier :supplierId="modelId" />
          </FormGroupBox>
        </b-tab>
        <b-tab
          v-if="modelId > 0 && $hasPermission('supplier.ratePlan')"
          title="Planes Tarifarios Proveedor" >
          <FormGroupBox title="Tarifas Proveedor">
            <template #append-title>
				<b-button class="ml-2" size="sm" variant="success" @click="addRatePlan" v-if="$hasPermission('rates.add')">
					<md-icon icon="add"/> Crear
				</b-button>
            </template>

            <b-table
              class="mt-3"
              stacked="sm"
              responsive="md"
              striped
              small
              hover
              bordered
              :fields="ratePlansColumns"
              :items="ratePlans"
            >
              <template v-slot:cell(startDate)="row">
                <div
                  class="d-flex flex-column"
                  :class="[
                    isValidateDate(row.item.endDate) ? '' : 'text-danger',
                  ]"
                >
                  <span class="u:text-size-2 text-muted m-0">
                    {{
                      row.item.startDate != null
                        ? formatDate(row.item.startDate, "DD/MM/YYYY")
                        : "Pendiente"
                    }}
                  </span>
                </div>
              </template>
              <template v-slot:cell(endDate)="row">
                <div
                  class="d-flex flex-column"
                  :class="[
                    isValidateDate(row.item.endDate) ? '' : 'text-danger',
                  ]"
                >
                  <span class="u:text-size-2 text-muted m-0"
                    ><md-icon
                      icon="info"
                      :class="[
                        row.item.endDate == null
                          ? ''
                          : isValidateDate(row.item.endDate)
                          ? 'text-success'
                          : 'text-danger',
                      ]"
                      :content="
                        row.item.endDate == null
                          ? 'Vecimiento no configurado'
                          : isValidateDate(row.item.endDate)
                          ? 'Tarifa activa'
                          : 'Tarifa expirado'
                      "
                      v-tippy="{ arrow: true, arrowType: 'round' }"
                    />
                    {{
                      row.item.endDate != null
                        ? formatDate(row.item.endDate, "DD/MM/YYYY")
                        : "Pendiente"
                    }}
                  </span>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="text-center">
                  <a
                    :href="`/rate-plans-edit?id=${row.item.id}`"
                    target="_blank"
					v-if="$hasPermission('prices.show')"
                    class="btn btn-sm mr-1 btn-warning px-0"
                    content="Edición de tarifa padre"
                    v-tippy="{ arrow: true, arrowType: 'round' }"
                  >
                    <md-icon icon="attach_money" />
                  </a>
                  <b-button
                    @click="(event) => viewRatePlan(row.item.id)"
                    type="button"
                    size="sm"
                    class="mr-1 px-0"
                    variant="primary"
                    content="Edición de plan tarifario"
                    v-tippy="{ arrow: true, arrowType: 'round' }"
                  >
                    <md-icon icon="edit" />
                  </b-button>
                  <b-button
					v-if="$hasPermission('rates.delete')"
                    @click="
                      (event) => deleteRatePlan(row.item, row.index, event)
                    "
                    type="button"
                    size="sm"
                    class="mr-1 px-0"
                    variant="danger"
                    content="Eliminar tarifa"
                    v-tippy="{ arrow: true, arrowType: 'round' }"
                  >
                    <md-icon icon="delete" />
                  </b-button>

                  <b-dropdown
					v-if="$hasPermission('rates.expire')"
                    id="dropdown-1"
                    text="Dropdown Button"
                    variant="success"
                    size="sm"
                    class="mr-1"
                    content="Cierre de tarifa"
                    v-tippy="{ arrow: true, arrowType: 'round' }"
                  >
                    <template #button-content
                      ><md-icon icon="price_check" />
                    </template>
                    <b-dropdown-item
                      @click="showOpcionsDateRate(row.item, 'expire')"
                      >Config. expiración de tarifa</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click="
                        showOpcionsDateRate(row.item, 'expireAndDuplicate')
                      "
                      >Config. expiración y duplicar tarifa</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </FormGroupBox>
          <RatePlanSingle
			:unableEdit="unableEditRatePlan"
			embbebedOnSupplier
			:supplierId="modelId"
            ref="ratePlanSingle"
            :success-callback="successCallbackRatePlan"
          />
        </b-tab>
		<b-tab v-if="modelId > 0 && $hasPermission('promotion.supplier.show')" title="Promociones">
			<TabPromotions :idSupplier="modelId"/>
		</b-tab>
		<b-tab v-if="modelId > 0" title="Configuraciones">
			<b-row>
				<b-col>
					<table class="table table-striped">
						<tr>
							<th></th>
							<th>Opción</th>
							<th>Descripcion</th>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientEmail"
								></b-form-checkbox>
							</td>
							<td>Mostrar el email del cliente en la plataforma de proveedor</td>
							<td>
								Controla la visibilidad del email del cliente dentro de la plataforma de proveedores
							</td>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientPhone"
								></b-form-checkbox>
							</td>
							<td>Mostrar el # de teléfono del cliente en la plataforma de proveedor</td>
							<td>
								Controla la visibilidad del # de teléfono del cliente dentro de la plataforma de proveedores
							</td>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientData24hrs"
								></b-form-checkbox>
							</td>
							<td>Mostrar el # de teléfono y correo del cliente solo con 24 horas de anticipacion al primer pickup</td>
							<td>
								<!-- Controla la visibilidad del # de teléfono del cliente dentro de la plataforma de proveedores -->
							</td>
						</tr>
					</table>

					<div class="text-right">
						<b-button
							@click="updateSettings()"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
				</b-col>
			</b-row>
		</b-tab>
      </b-tabs>
    </div>
    <!-- modal cierre de tarifa -->
    <b-modal
      hide-footer
      ref="refClosingRate"
      size="md"
      :title="
        TypeOfClousure == 'expire'
          ? 'Config. expiración de tarifa'
          : 'Config. expiración y duplicar tarifa'
      "
    >
      <ClosingRateModal
        @closeModal="$refs['refClosingRate'].hide()"
        ref="refBodyCloseRate"
        :TypeOfClousure="TypeOfClousure"
        @refreshTableRate="loadRatePlans()"
      />
    </b-modal>
  </b-modal>
</template>

<script>
import moment from "moment";
import RatePlanSingle from "../rate-plans/Single";
import FormGroupBox from "../../helpers/FormGroupBox";
import ClosingRateModal from "../rate-plans/ClosingRateModal.vue";
import TabPromotions from "./Promotions/indexPromotions.vue";
import ServiceTypeTable from "../service-types/Table.vue"
export default {
  props: {
	unableEdit: Boolean,
    successCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  components: { RatePlanSingle, FormGroupBox, ClosingRateModal, TabPromotions, ServiceTypeTable },
  data() {
    let defaultModelInfo = {
		id: -1,
		code: "",
		name: "",
		description: "",
		onDemandServices: false,
		taxName: "",
		status: "active",
		emailNotifications:"",
		languageNotifications:"es"
    };
	const defaultSettings ={showClientPhone:false,showClientEmail:false,showClientData24hrs:false}
    return {
		modelId: -1,
		loading: true,
		ratePlans: [],
			unableEditRatePlan: false,
		serviceTypesIds: [],
		modelInfo: { ...defaultModelInfo },
		defaultModelInfo: { ...defaultModelInfo },
		statusOptions: [
			{ value: "active", text: "Activo" },
			{ value: "inactive", text: "Inactivo" },
		],
		langOptions: [
			{ value: "es", text: "Español [ES]" },
			{ value: "en", text: "Ingles [EN]" },
		],
		ratePlansColumns: [
			{ key: "id", label: "Id" },
			{ key: "name", label: "Nombre" },
			{ key: "zonedAreaName", label: "Area", sortable: true },
			{ key: "supplierZonedAreaName", label: "Area proveedor", sortable: true },
			{ key: "currency", label: "Moneda" },
			{ key: "heritance", label: "Conf. Herencia" },
			{ key: "rateType", label: "Tipo" },
			{ key: "startDate", label: "F.Inicio", sortable: true },
			{ key: "endDate", label: "F.Vecimiento", sortable: true },
			{ key: "actions", label: "Acciones" },
		],
		filters: {
			search: "",
		},
		currentTab: "general",
		filterRates: "Vigentes",
		TypeOfClousure: "expire",
		defaultSettings: {...defaultSettings},
		settings: {...defaultSettings}
    };
  },
  computed: {
    serviceTypesOpts() {
      return this.$root.auxVars.serviceTypesOpts.filter((st) => st.value != 1);
    },
  },
  mounted() {
    this.loadRatePlans();
    this.$root.auxVars.loadResourcesOpts({
      vm: this,
      resourceNames: ["serviceTypesOpts"],
    });
    // console.log(this.isValidateDate("2022-04-11 10:51:34"));
  },
  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    },
    isNotExpiredRate(fecha) {
      //validamos que el campo sea distinto de null
      if (fecha != null) {
        let today = moment(new Date().toDateString()).format(
          "YYYY-MM-DD h:mm:ss"
        );

        let fechaProcesada = moment(fecha).format('"YYYY-MM-DD h:mm:ss');
        console.log(
          moment(today).toDate() + "=" + moment(fechaProcesada).toDate()
        );
        console.log(moment(today).toDate() <= moment(fechaProcesada).toDate());
        return moment(today).toDate() <= moment(fechaProcesada).toDate();
      }
      return false;
    },
    isValidateDate(fecha) {
      //validamos que el campo sea distinto de null
      if (fecha != null) {
        //obtenemos la fecha actual
        let today = moment().format("YYYY-MM-DD h:mm:ss");
        return (
          moment(today).toDate() <= moment(fecha, "YYYY-MM-DD h:mm:ss").toDate()
        );
      }
      return false;
    },
    showOpcionsDateRate(itemRate, status) {
      let me = this;
      this.$refs["refClosingRate"].show();
      setTimeout(function () {
        me.$refs.refBodyCloseRate.setTypeOfClousure(status);
        me.$refs.refBodyCloseRate.setRate(itemRate);
      }, 200);
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.$listeners.submit) {
        this.$listeners.submit(event);
        return;
      }
      this.loading = true;
      let rParams = {
        url: this.modelId > 0 ? `/suppliers/${this.modelId}` : "/suppliers",
        method: this.modelId > 0 ? "put" : "post",
      };
      if (rParams.method == "get") {
        rParams["params"] = this.modelInfo;
      } else {
        rParams["data"] = this.modelInfo;
      }
      this.$root.api
        .request(rParams)
        .then((res) => {
          this.$root.showAlert("OK!");
          if (res.data.id) this.loadModel(res.data.id);
          this.successCallback(res);
          this.$root.auxVars.resetResource("suppliersOpts");
        })
        .catch(this.$root.handleRequestError)
        .then(() => {
          this.loading = false;
        });
    },
    loadModel(id) {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"],
			forceRefresh: true,
		});
		this.modelId = id;
		this.$refs["modal-view"].show();
		this.settings = {...this.defaultSettings}
		this.fetchModel();
    },
    fetchModel() {
      if (this.modelId > 0) {
        this.loading = true;
        this.$root.api
          .get(`/suppliers/${this.modelId}`)
          .then((res) => {
            this.modelInfo = { ...res.data };
			this.settings  = { ...this.modelInfo.settingVars}
            this.loadRatePlans();
            this.loading = false;
          })
          .catch(this.$root.handleRequestError);
      } else {
        this.modelInfo = { ...this.defaultModelInfo };
        this.loading = false;
      }
    },
    viewRatePlan(id) {
		this.unableEditRatePlan =  !this.$hasPermission("rates.edit");
      this.$refs["ratePlanSingle"].loadModel(id);
    },
    addRatePlan() {
      this.$refs["ratePlanSingle"].loadModel(-1);
      this.$refs["ratePlanSingle"].setSupplierId(this.modelId);
    },
    loadRatePlans() {
      if (this.modelId > 0 && this.$hasPermission('rates.show')) {
        this.$root.api
          .get(`/suppliers/${this.modelId}/rate-plans`)
          .then((res) => {
            this.ratePlans = res.data;
          })
          .catch(this.$root.handleRequestError);
      }
    },
    successCallbackRatePlan() {
      this.loadRatePlans();
    },
    deleteRatePlan(item) {
      this.$root.showWarning({
        okAction: (event, setLoading, close) => {
          setLoading(true);
          this.$root.api
            .delete(`/rate-plans/${item.id}/suppliers/${this.modelId}`)
            .then(() => {
              this.$root.showAlert("Registro Eliminado!", {
                variant: "warning",
              });
              this.loadRatePlans();
              close();
            })
            .catch((err) => {
              this.$root.handleRequestError(err);
              close();
            });
        },
      });
    },
	updateSettings(){
		this.loading = true
		let settings = {
			showClientPhone : this.settings.showClientPhone,
			showClientEmail : this.settings.showClientEmail,
			showClientData24hrs : this.settings.showClientData24hrs
		}
		this.$root.api.put(`/suppliers/${this.modelId}/setting-vars`,{ settings }).then(() => {
			this.$root.showAlert('Configuraciones actualizadas')
			this.loading = false
		}).catch(this.$root.handleRequestError);
	}
  },

  watch: {},
};
</script>

<style>
</style>
